/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OutsideInputs */

const en_nav_outside = /** @type {(inputs: Nav_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside`)
};

/**
* | output |
* | --- |
* | "Outside" |
*
* @param {Nav_OutsideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_outside = /** @type {((inputs?: Nav_OutsideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OutsideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_outside(inputs)
});